import { createFileRoute } from '@tanstack/react-router';
import { GAME_MASTERS, GameMasterCard } from '@/components/site/GameMasterCard';

export const Route = createFileRoute('/_site/game-masters')({
  head: () => ({
    meta: [
      { title: 'Game masters — Jack and Sophia | Everwake' },
      {
        name: 'description',
        content:
          'Choose between two AI game masters: Jack for a tense, decisive table or Sophia for a calm, richly observed evening.',
      },
      { property: 'og:title', content: 'Game masters — Jack and Sophia' },
      {
        property: 'og:description',
        content:
          'Jack runs a tense table, Sophia a calm one. Same character, same seed, same dice under either.',
      },
      { property: 'og:type', content: 'article' },
      { name: 'twitter:card', content: 'summary_large_image' },
    ],
  }),
  component: GameMasters,
});

function GameMasters() {
  return (
    <div className="mx-auto max-w-5xl px-5 py-16">
      <p className="rule-line">Game masters</p>
      <h1 className="mt-4 font-display text-4xl md:text-5xl">
        Two ways to be told a story
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
        Your game master is an AI system. It has a manner and a voice, and you choose which one sits opposite you.
      </p>

      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {GAME_MASTERS.map((master) => (
          <GameMasterCard key={master.id} master={master} heading="h2" showScene />
        ))}
      </div>

      <p className="mt-12 rounded-xl border border-primary/40 bg-primary/5 p-6 font-semibold">
        Choose the voice and rhythm you enjoy. Your character, world seed and dice remain true across both storytellers.
      </p>
    </div>
  );
}
